export const DEFAULT = 0; // DEFAULT

export const MSD_CTIO_A = 101;
export const MSD_CTIO_B = 102;
export const MSD_CTIO_C = 100;